import type { DropTargetOptions } from '@hive/component';
import { isFavoriteSupportType } from '@hive/core/modules/favorite';
import type { HiveDNDData } from '@hive/core/types/dnd';

import type { ExplorerTreeNodeDropEffect } from '../../tree';

export const favoriteChildrenDropEffect: ExplorerTreeNodeDropEffect = data => {
  if (
    data.treeInstruction?.type === 'reorder-above' ||
    data.treeInstruction?.type === 'reorder-below'
  ) {
    if (
      data.source.data.from?.at === 'explorer:favorite:list' &&
      data.source.data.entity?.type &&
      isFavoriteSupportType(data.source.data.entity.type)
    ) {
      return 'move';
    } else if (
      data.source.data.entity?.type &&
      isFavoriteSupportType(data.source.data.entity.type)
    ) {
      return 'link';
    }
  }
  return; // not supported
};

export const favoriteRootDropEffect: ExplorerTreeNodeDropEffect = data => {
  const sourceType = data.source.data.entity?.type;
  if (sourceType && isFavoriteSupportType(sourceType)) {
    return 'link';
  }
  return;
};

export const favoriteRootCanDrop: DropTargetOptions<HiveDNDData>['canDrop'] =
  data => {
    return data.source.data.entity?.type
      ? isFavoriteSupportType(data.source.data.entity.type)
      : false;
  };

export const favoriteChildrenCanDrop: DropTargetOptions<HiveDNDData>['canDrop'] =
  // Same as favoriteRootCanDrop
  data => favoriteRootCanDrop(data);
